import axios from 'axios';
import { AnyAction } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { AppState } from 'src/redux/types';
import APIS from 'src/utils/apiUrl';
import { getAuthToken } from 'src/utils/auth/getAuthToken';
import { authActions } from '../actions';
import { SentinelUserInfo } from './sentinelUserInfo';
import { Organization } from '../../../models/organization';

/** A thunk action which fetches information about the current user from the portal system. */
export const fetchGuestInfo = (): ThunkAction<void, AppState, undefined, AnyAction> => async dispatch => {
  dispatch(authActions.fetchUserStart());
  const token = await getAuthToken();
  if (!token) throw new Error('Tried to fetch user info without an auth token!');
  const accessToken = token.access.token;
  const opts = { headers: { Authorization: `Bearer ${accessToken}` } };

  let guestInfo: SentinelUserInfo;
  try {
    const { data } = await axios.get(`${APIS.PORTAL_API}/api/job-report-guests/get`, opts);
    guestInfo = data;
    if (!guestInfo._id || !guestInfo.org || typeof guestInfo.role !== 'number') {
      dispatch(authActions.fetchUserFailure());
      throw new Error(`Invalid user info object: ${JSON.stringify(guestInfo)}`);
    }
  } catch (err) {
    console.error('Failed to fetch guest info', err);
    dispatch(authActions.fetchUserFailure());
    throw new Error(`Error fetching user info for guest user: ${err}`);
  }

  try {
    const { data: org }: { data: Organization } = await axios.get(`${APIS.PORTAL_API}/api/organizations/get`, opts);
    if (!org._id || !org.status) {
      dispatch(authActions.fetchUserFailure());
      throw new Error(`Invalid org object: ${JSON.stringify(org)}`);
    }
    dispatch(
      authActions.fetchUserSuccess({
        user: {
          id: guestInfo._id,
          org: guestInfo.org,
          orgDetails: org,
          controllers: [],
          role: guestInfo.role,
          status: guestInfo.status,
          givenName: guestInfo.given_name ?? undefined,
          familyName: guestInfo.family_name ?? undefined,
          email: guestInfo.email ?? undefined,
          tosAcceptedAt: guestInfo.sentinelLinkTOSAcceptedAt ?? undefined,
        },
      }),
    );
    console.log('successfully retrieved org for guest user: ', org);
  } catch (err) {
    dispatch(authActions.fetchUserFailure());
    throw new Error(`Error fetching org for guest user: ${err}`);
  }
};
